import { Form, Input, DatePicker, Button } from 'antd'
import React from 'react'

function Filters({ onSubmit }) {
  const onFinish = (value) => {
    onSubmit({
      ...value,
    })
  }
  return (
    <Form
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 14 }}
      layout="horizontal"
      onFinish={onFinish}
    >
       <Form.Item label="Email" name="Email">
        <Input />
      </Form.Item>
      <Form.Item label="Mesaj" name="Message">
        <Input />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Filtrele
        </Button>
      </Form.Item>
    </Form>
  )
}


export default Filters
